module.exports = __webpack_public_path__ + "static/media/nature-bird.275081f2.png";